import React from "react";
import PageHero from "../../PageHero";
import { useHistory, useParams } from "react-router-dom";
import EmployeeGroup from "../../../types/EmployeeGroup";
import { Api } from "../../../api";
import { hasError } from "../../../helpers/ResponseHelper";
import { CompanyContext } from "../../../context/CompanyContext";
import AdminGroupDetailsEmployees from "./AdminGroupDetailsEmployees";
import { Container, Tabs, Tab } from "@material-ui/core";
import TabPanel from "../../TabPanel";
import AdminGroupDetailsAssignments from "./AdminGroupDetailsAssignments";
import AdminGroupDetailsDocuments from "./AdminGroupDetailsDocuments";
import { DocumentType } from "../../../types/Document";

export default function AdminGroupDetailsPage() {
  const { groupId } = useParams();
  const [group, setGroup] = React.useState<EmployeeGroup>();
  const history = useHistory();
  const company = React.useContext(CompanyContext);
  const [tab, setTab] = React.useState("employees");

  React.useEffect(() => {
    if (groupId) {
      Api.groups.getOne(groupId).then((res) => {
        console.log(res);
        if (!hasError(res)) {
          setGroup(res.data.data);
        }
      });
    }
  }, [groupId]);

  return (
    <div>
      <PageHero
        backhandler={() => history.goBack()}
        title={group?.groupName}
        showBack={true}
      />
      <div className="content-paper">
        <Container maxWidth="xl">
          {groupId ? (
            <>
              <Tabs
                className="tabs-line"
                style={{ marginBottom: 20 }}
                value={tab}
                indicatorColor="secondary"
                variant="scrollable"
                scrollButtons="auto"
              >
                <Tab
                  label="Employees"
                  className="tab"
                  value="employees"
                  onClick={() => setTab("employees")}
                />
                <Tab
                  label="Assignments"
                  className="tab"
                  value="assignments"
                  onClick={() => setTab("assignments")}
                />
                <Tab
                  label="Handbooks &amp; Manuals"
                  className="tab"
                  value="handbooks"
                  onClick={() => setTab("handbooks")}
                />
                <Tab
                  label="Forms"
                  className="tab"
                  value="forms"
                  onClick={() => setTab("forms")}
                />
              </Tabs>
              <TabPanel value="employees" index={tab}>
                <AdminGroupDetailsEmployees
                  companyId={company.companyId}
                  groupId={groupId}
                />
              </TabPanel>
              <TabPanel value="assignments" index={tab}>
                <AdminGroupDetailsAssignments groupId={groupId} />
              </TabPanel>
              <TabPanel value="handbooks" index={tab}>
                <AdminGroupDetailsDocuments
                  groupId={groupId}
                  type={DocumentType.Handbook}
                />
              </TabPanel>
              <TabPanel value="forms" index={tab}>
                <AdminGroupDetailsDocuments
                  groupId={groupId}
                  type={DocumentType.Form}
                />
              </TabPanel>
            </>
          ) : null}
        </Container>
      </div>
    </div>
  );
}
